<template>
  <section
    ref="slide"
    :class="{ mounted: mounted === true }"
    class="introslide flex flex-col justify-center min-h-screen bg-workbook-orange pt-12">
    <UContainer>
      <UPageGrid class="headline mt-10 lg:mt-0 text-white">
        <div class="col-span-4 lg:col-span-5">
          <TripleLogo ref="logo" class="mb-0 mt-12 xl:mb-20 triple-logo" />
          <h1 class="mb-12 lg:mb-2 leading-[70px] text-7xl">
            The visual B2B sales workbook, built for sell-in and ordering
          </h1>

        </div>
        <div class="col-span-4 lg:col-span-7 pb-4 lg:pb-0">
          <ClientOnly>
          <WorkbookIntroMonitor :text1="'From brand story to confirmed orders.'" :text2="'Present collections, tell your seasonal story, and turn sell-in into orders, all in one visual workbook.'" />
          </ClientOnly>
          <p class="text-workbook-black text-center lg:text-right mb-0">Kudo Sales is created by: <a href="https://hjartat.net" target="_blank" rel="noopener noreferrer" aria-label="Visit Hjartat.net"><WorkbookIcon class="ml-1" name="workbook:hjartat" :color="'black'" /></a> </p>
        </div>
        
      </UPageGrid>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

import { loadGsap } from '@/utils/gsap'

const mounted = ref(false)
const slide = ref<HTMLElement | null>(null)
let ctx: gsap.Context | null = null

onMounted(async () => {
  mounted.value = true

  

  const { gsap } = await loadGsap()

  const logoPaths = slide.value?.querySelectorAll('.triple-logo path') as NodeListOf<SVGPathElement> | undefined
  const headline = slide.value?.querySelectorAll('h1') as NodeListOf<HTMLElement> | undefined

  if (logoPaths && logoPaths.length) {
    ctx = gsap.context(() => {
      gsap.to(logoPaths, {
        delay: 0.12,
        x: (i) => i * 2,
        duration: (i) => (i + 1) * 0.2
      })

      const logoTl = gsap.timeline({
        scrollTrigger: {
          trigger: slide.value,
          pin: false,
          markers: false,
          start: 'bottom 98%',
          end: 'bottom 30%',
          scrub: 1.2
        }
      })

      logoTl.add('out')

      logoTl.to(
        logoPaths,
        {
          y: (i) => i * 80,
          x: 0,
          opacity: 0,
          scale: 5,
          duration: (i) => (i + 1) * 0.8
        },
        'out'
      )

      if (headline && headline.length) {
        logoTl.to(
          headline,
          {
            y: 50,
            opacity: 0,
            duration: 0.5,
            stagger: -0.3
          },
          'out'
        )
      }
    }, slide.value || undefined)
  }
})

onUnmounted(() => {
  ctx?.revert()
  ctx = null
})
</script>
